import { render } from "./SellerSidebar.vue?vue&type=template&id=2ca6b97e&scoped=true"
import script from "./SellerSidebar.vue?vue&type=script&lang=js"
export * from "./SellerSidebar.vue?vue&type=script&lang=js"

import "./SellerSidebar.vue?vue&type=style&index=0&id=2ca6b97e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ca6b97e"]])

export default __exports__